import { useDrawingArea } from '@mui/x-charts';
import { formatDate } from '../../../../../../../../utils/date';

type ProductUsageBreakdownChartOverageOverlayProps = {
  xAxisOverlayRatio: number;
  overageCrossedDate?: Date;
};

export const ProductUsageBreakdownChartOverageOverlay: React.FC<
  ProductUsageBreakdownChartOverageOverlayProps
> = ({ xAxisOverlayRatio, overageCrossedDate }) => {
  const { left, top, height, width } = useDrawingArea();
  const xStart = width * xAxisOverlayRatio + left;

  const cutoffWidth = width - xStart + left;

  const dateToDisplay = overageCrossedDate ?? new Date();

  return (
    <>
      <text
        x={xStart + cutoffWidth - 14}
        y={top + 22}
        fill="#DD0038"
        fontSize={12}
        fontWeight={400}
        fontFamily="Inter, sans-serif"
        textAnchor="end"
      >
        {`Overages crossed on`}
      </text>
      <text
        x={xStart + cutoffWidth - 70}
        y={top + 38}
        fill="#DD0038"
        fontSize={12}
        fontWeight={400}
        fontFamily="Inter, sans-serif"
        textAnchor="end"
      >
        {formatDate(dateToDisplay)}
      </text>
      <rect x={xStart} y={top - 1} width={cutoffWidth} height={height} fill="#FF4666" fillOpacity={0.2} />
    </>
  );
};
